import staff from "../../../data/staff.json";
import styles from "./all-stylists.module.scss";
import { Variants, motion } from "framer-motion";

function getRandomFloat(min: number, max: number) {
  return Math.random() * (max - min) + min;
}

const teamMembers = [
  ...staff.manager,
  ...staff.frontDesk,
  ...staff.assistants,
];

const AllStylists = () => {
  const imageVariants: Variants = {
    imageOffScreen: {
      scale: 0.6,
      opacity: 0,
      zIndex: -11,
    },
    imageOnScreen: {
      scale: 1,
      opacity: 1,
      zIndex: 0,
      transition: {
        duration: getRandomFloat(0.5, 1.0),
      },
    },
  };

  const StaffCard = ({ person }: { person: { name: string; img: { url: string } } }) => (
    <motion.div
      initial="imageOffScreen"
      whileInView="imageOnScreen"
      variants={imageVariants}
      className={styles["staff-card"]}
    >
      <div className={styles["photo-wrapper"]}>
        <img
          draggable={false}
          loading="lazy"
          src={person.img.url}
          alt={person.name}
        />
      </div>
      <p className={styles["staff-name"]}>{person.name.trim().split(/\s+/)[0]}</p>
    </motion.div>
  );

  return (
    <>
      <div className={styles["container"]}>
        <div className={styles["staff-container"]}>
          <section className={styles["section"]}>
            <h1 className={styles["section-title"]}>Stylists</h1>
            <div className={styles["staff-grid"]}>
              {staff.stylists.map((stylist, index) => (
                <StaffCard key={`stylist${index}`} person={stylist} />
              ))}
            </div>
          </section>

          <section className={styles["section"]}>
            <h1 className={styles["section-title"]}>In-House Staff</h1>
            <div className={styles["staff-grid"]}>
              {teamMembers.map((member, index) => (
                <StaffCard key={`team${index}`} person={member} />
              ))}
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default AllStylists;
